<template>
  <BasePage :pageTitle=__DICT__.passengerSearch show-menu show-footer>
    <div class="card mb-4">
      <div class="card-body">
        <div class="input-icon">
          <input
              type="text"
              class="form-control"
              :placeholder="__DICT__.enterNameOrBooking"
              v-model="searchQuery"
              @input="searchPassengers"
          >
          <span class="input-icon-addon">
              <IconSearch class="icon" :size="24" />
            </span>
        </div>

        <div v-if="filteredPassengers.length > 0" class="table-responsive">
          <table class="table table-vcenter card-table mt-2">
            <thead>
            <tr>
              <th>{{ __DICT__.name }}</th>
              <th>{{ __DICT__.bookingRef }}</th>
            </tr>
            </thead>
            <tbody>
            <tr @click="selectPassenger(passenger)" v-for="passenger in filteredPassengers" :key="passenger.id">
              <td>{{ passenger.passengerName }}</td>
              <td>{{ passenger.reference }}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <div v-else-if="searchQuery && !isLoading" class="empty">
          <div class="empty-icon">
            <IconMoodSad class="icon" :size="24" />
          </div>
          <p class="empty-title">{{ __DICT__.noResultsFound }}</p>
          <p class="empty-subtitle text-muted">
            {{ __DICT__.tryAdjustingSearch }}
          </p>
        </div>

        <div v-if="isLoading" class="text-center mt-3">
          <div class="spinner-border text-blue" role="status"></div>
          <span class="ms-2">{{ __DICT__.searching }}</span>
        </div>
      </div>
    </div>
  </BasePage>
</template>
<script setup>
import {ref, computed, onMounted} from 'vue'
import {useWeekStore} from '@/stores/week.js'
import {usePermissions} from '@/composables/usePermissions'
import {passengerIndex} from '@/services/PassengerIndex.js'
import BasePage from "@/components/BasePage.vue";
import router from "@/router/index.js";
import { IconSearch, IconMoodSad } from '@tabler/icons-vue';

const weekStore = useWeekStore()
const {filter, context} = usePermissions()
const searchQuery = ref('')
const isLoading = ref(true)
const weekData = ref([])

const filteredPassengers = computed(() => {
  if (!searchQuery.value) return []

  const brand = context.value?.brand
  const level = context.value?.rep?.level || 0

  // Snowfuze is the admin/umbrella brand — no passengers have 'SNOWFUZE-' references,
  // so brand filtering makes no sense. Level 2+ on any brand can also view all.
  const canViewAll = brand === 'snowfuze' || level >= 2

  if (canViewAll) {
    return passengerIndex.search(searchQuery.value, { limit: 100 })
  } else {
    // Level 1 non-snowfuze reps: filter by their brand
    return passengerIndex.search(searchQuery.value, {
      limit: 100,
      brand
    })
  }
})

async function loadWeekData() {
  isLoading.value = true
  try {
    weekData.value = weekStore.weekData || []
  } catch (error) {
    console.error('Error loading week data:', error)
  } finally {
    isLoading.value = false
  }
}

function searchPassengers() {
}

function selectPassenger(passenger) {
  router.push(`/passenger/${passenger.reference}`)
}

onMounted(() => {
  loadWeekData()
})
</script>
